exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-small[data-v-808e001e]{width:128px}", ""]);

// exports
